module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "specialist-icon.c0a179ca.png";